import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

export default function GetAppointmentTime({ id, date, status, inDate, outDate, AppointmentPage}) {
    const { totalTimes } = useSelector((state) => ({
        totalTimes: state.setting.totalTimes,
    }));
    const [time, setTime] = useState(null);
    useEffect(() => {
        setTime(null);
    },[])
    useEffect(() => {
        if(id && (status === 6 || status === 4)) {
            if(totalTimes) {
                const h = totalTimes.find(item => {
                    if(+item.id === +id.split('/')[0])
                        return item
                    });
                let min = '00';
                try {
                    if(id.split('/')[1]) min = id.split('/')[1];
                } catch {
                    min = '00';
                }
                setTime(`${h.name.replace(':00','')}:${min}`);
            } else {
                setTime('');
            }
        }
    },[totalTimes, status])
    return (
        <>
            {
                (time && time !== '' && ((status === 4 && inDate) || (status === 6 && (outDate || AppointmentPage))))
                ? <span>{`${date} - ${time}`}</span>
                : <span>{date}</span>
            }
        </>
    )
}